// digitalefotolijst.nl theme JS
// cache-bust: forceer nieuwe ?v=-hash, Shopify CDN bleef oude asset uitleveren
(function(){
  'use strict';

  // Sticky header shadow
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive:true });
    onScroll();
  }

  // Mobile menu toggle
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (mobileMenu) mobileMenu.classList.toggle('open');
      // Close search if open
      document.querySelector('[data-search-drawer]')?.classList.remove('open');
    });
  });

  // Search drawer toggle
  const searchDrawer = document.querySelector('[data-search-drawer]');
  document.querySelectorAll('[data-search-toggle]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (searchDrawer) {
        searchDrawer.classList.toggle('open');
        if (searchDrawer.classList.contains('open')) {
          searchDrawer.querySelector('input')?.focus();
        }
      }
      // Close mobile menu if open
      mobileMenu?.classList.remove('open');
    });
  });

  // Tabs
  document.querySelectorAll('[data-tab-bar]').forEach(bar => {
    const buttons = bar.querySelectorAll('[data-tab]');
    const container = bar.closest('[data-tabs]') || bar.parentElement;
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        buttons.forEach(b => b.classList.toggle('active', b === btn));
        container.querySelectorAll('[data-tab-panel]').forEach(p => {
          p.classList.toggle('active', p.dataset.tabPanel === target);
        });
      });
    });
  });

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(item => {
    const q = item.querySelector('.faq-q');
    if (q) q.addEventListener('click', () => item.classList.toggle('open'));
  });

  // PDP gallery + lightbox
  document.querySelectorAll('[data-pdp-gallery]').forEach(gallery => {
    const main = gallery.querySelector('[data-pdp-main]');
    const mainImg = main && main.querySelector('img');
    const thumbs = gallery.querySelectorAll('[data-pdp-thumb]');

    function collectImages() {
      const imgs = [];
      if (mainImg) imgs.push({ src: upscale(mainImg.src), alt: mainImg.alt || '' });
      thumbs.forEach(t => {
        if (t.dataset.src) imgs.push({ src: upscale(t.dataset.src), alt: t.dataset.alt || '' });
      });
      // dedupe by base src (ignore width query)
      const seen = new Set();
      return imgs.filter(i => { const k = i.src.split('?')[0]; if (seen.has(k)) return false; seen.add(k); return true; });
    }
    function upscale(url) {
      if (!url) return url;
      // Scale to viewport*DPR, capped at 1600 — much faster than always 1800
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const target = Math.min(Math.ceil((window.innerWidth || 1200) * dpr), 1600);
      return url.replace(/width=\d+/, 'width=' + target).replace(/&height=\d+/, '');
    }
    function currentIndex(images) {
      if (!mainImg) return 0;
      const cur = mainImg.src.split('?')[0].replace(/width=\d+/, '').replace('&', '');
      const i = images.findIndex(im => im.src.split('?')[0].includes(cur.split('/').pop().split('.')[0]));
      return Math.max(0, i);
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (main && thumb.dataset.src) {
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt || '';
        }
      });
    });

    if (mainImg) {
      mainImg.style.cursor = 'zoom-in';
      mainImg.addEventListener('click', () => {
        const imgs = collectImages();
        openLightbox(imgs, currentIndex(imgs));
      });
    }
  });

  // Lightbox overlay
  function openLightbox(images, startIdx) {
    if (!images.length) return;
    let idx = Math.max(0, Math.min(startIdx || 0, images.length - 1));
    const ov = document.createElement('div');
    ov.className = 'lb';
    ov.innerHTML = `
      <button class="lb-close" aria-label="${window.DFL.i18n.close}">&times;</button>
      ${images.length > 1 ? '<button class="lb-prev" aria-label="' + window.DFL.i18n.previous + '">&lsaquo;</button>' : ''}
      <div class="lb-stage"><img alt=""></div>
      ${images.length > 1 ? '<button class="lb-next" aria-label="' + window.DFL.i18n.next + '">&rsaquo;</button>' : ''}
      ${images.length > 1 ? '<div class="lb-count"></div>' : ''}
    `;
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';
    const img = ov.querySelector('img');
    const count = ov.querySelector('.lb-count');
    const stage = ov.querySelector('.lb-stage');
    function preload(src) { const i = new Image(); i.src = src; }
    function update() {
      stage.classList.add('is-loading');
      img.onload = () => stage.classList.remove('is-loading');
      img.onerror = () => stage.classList.remove('is-loading');
      img.src = images[idx].src;
      img.alt = images[idx].alt;
      if (count) count.textContent = `${idx + 1} / ${images.length}`;
      // Preload neighbours for instant swipe
      if (images.length > 1) {
        preload(images[(idx + 1) % images.length].src);
        preload(images[(idx - 1 + images.length) % images.length].src);
      }
    }
    function close() {
      ov.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }
    function next() { idx = (idx + 1) % images.length; update(); }
    function prev() { idx = (idx - 1 + images.length) % images.length; update(); }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft') prev();
    }
    ov.querySelector('.lb-close').addEventListener('click', close);
    const nx = ov.querySelector('.lb-next'); if (nx) nx.addEventListener('click', next);
    const pv = ov.querySelector('.lb-prev'); if (pv) pv.addEventListener('click', prev);
    ov.addEventListener('click', e => { if (e.target === ov) close(); });
    document.addEventListener('keydown', onKey);

    // Touch swipe
    let startX = null;
    ov.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    ov.addEventListener('touchend', e => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { dx > 0 ? prev() : next(); }
      startX = null;
    });

    update();
  }

  // Variant swatches (syncs with variant selector)
  document.querySelectorAll('[data-variant-swatches]').forEach(el => {
    const select = document.querySelector(el.dataset.variantTarget || '[name="id"]');
    el.querySelectorAll('[data-variant-id]').forEach(sw => {
      sw.addEventListener('click', () => {
        el.querySelectorAll('[data-variant-id]').forEach(s => s.classList.remove('active'));
        sw.classList.add('active');
        if (select) { select.value = sw.dataset.variantId; select.dispatchEvent(new Event('change')); }
      });
    });
  });

  // PDP image-badge A/B-test: kiest 1 variant per bezoeker (niet per page-load),
  // blijft 30 dagen consistent (localStorage, zelfde patroon als page-attribution.liquid),
  // en schrijft de gekozen variant als cart-attribute zodat 'ie op de order
  // terechtkomt (Shopify Admin → bestelling → Aanvullende gegevens).
  //
  // initPdpImageBadge draait bij normale page-load ÉN bij shopify:section:load —
  // dat laatste event vuurt Shopify's Theme Editor elke keer dat een merchant
  // een instelling live wijzigt (AJAX-herrender, geen volledige page-reload).
  // Zonder die listener blijft de badge in de Editor-preview onzichtbaar zodra
  // je de toggle live aanzet, ook al werkt 'ie prima op de echte site.
  function initPdpImageBadge(scope) {
    var root = (scope || document).querySelector('[data-pdp-image-badge]');
    if (!root || root.dataset.badgeInitDone) return;
    var options = root.querySelectorAll('[data-badge-variant]');
    if (!options.length) return;
    root.dataset.badgeInitDone = '1';

    var STORAGE_KEY = '_dfl_badge_variant';
    var TTL_DAYS = 30;
    var idx = 0;
    var forced = root.dataset.forcedVariant;

    if (forced !== undefined && forced !== '' && Number(forced) < options.length) {
      idx = Number(forced);
    } else {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        var stored = raw ? JSON.parse(raw) : null;
        var age = stored ? Date.now() - new Date(stored.time).getTime() : Infinity;
        if (stored && age < TTL_DAYS * 24 * 60 * 60 * 1000 && stored.idx < options.length) {
          idx = stored.idx;
        } else {
          idx = Math.floor(Math.random() * options.length);
          localStorage.setItem(STORAGE_KEY, JSON.stringify({ idx: idx, time: new Date().toISOString() }));
        }
      } catch (e) {
        idx = Math.floor(Math.random() * options.length);
      }
    }

    options.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
    root.hidden = false;

    var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root_url + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      keepalive: true,
      body: JSON.stringify({ attributes: { '_pdp_badge_variant': String(idx) } })
    }).catch(function () {});
  }
  initPdpImageBadge(document);
  document.addEventListener('shopify:section:load', function (e) { initPdpImageBadge(e.target); });

  // Helper: format cents → "€X,XX"
  function fmtCents(cents) { return '€' + (cents/100).toFixed(2).replace('.', ','); }

  // Zelfde als fmtCents maar trimt ",00" — matcht Liquid's money_without_trailing_zeros
  // (nodig omdat de bulk-tier kaarten server-side met die filter gerenderd zijn)
  function fmtCentsTrimmed(cents) {
    const hasFraction = Math.round(cents) % 100 !== 0;
    return hasFraction ? fmtCents(cents) : '€' + Math.round(cents / 100);
  }

  // Herbereken elke bulk-tier kaart (prijs/stuk, besparing, doorgestreepte prijs) op
  // basis van de NIEUW gekozen variant. Zonder dit bleven de tier-kaarten hangen op de
  // prijs van de variant die bij page-load actief was (bug: prijs klopte niet meer na
  // variant-switch, zowel op de kaart zelf als in het ATC-totaal).
  function updateBulkTiersForVariant(baseCents) {
    const bulkRoot = document.querySelector('[data-bulk-tiers]');
    if (!bulkRoot || isNaN(baseCents)) return;
    bulkRoot.querySelectorAll('[data-bulk-tier]').forEach(btn => {
      const pct = parseFloat(btn.dataset.tierPct || '0');
      const unitCents = pct > 0 ? Math.round(baseCents - (baseCents * pct / 100)) : baseCents;
      btn.dataset.tierUnitCents = unitCents;

      const qty = parseInt(btn.dataset.tierQty, 10) || 1;
      const priceNumEl = btn.querySelector('.bulk-tier-price-num');
      if (priceNumEl) priceNumEl.textContent = fmtCentsTrimmed(unitCents);

      const savingsNumEl = btn.querySelector('.bulk-tier-savings-num');
      if (savingsNumEl) savingsNumEl.textContent = fmtCentsTrimmed((baseCents - unitCents) * qty);

      const compareEl = btn.querySelector('.bulk-tier-compare');
      if (compareEl) compareEl.textContent = fmtCentsTrimmed(baseCents);
    });
  }
  window.updateBulkTiersForVariant = updateBulkTiersForVariant;

  // Herbereken ATC button prijs: qty × applicable-tier-unit
  function updateAtcForQty(qty) {
    const priceEl = document.querySelector('[data-atc-price]');
    if (!priceEl) return;
    const baseCents = parseInt(priceEl.dataset.atcBaseCents || '0', 10);
    let unitCents = baseCents;
    const bulkRoot = document.querySelector('[data-bulk-tiers]');
    if (bulkRoot) {
      const tiers = Array.from(bulkRoot.querySelectorAll('[data-bulk-tier]'))
        .map(b => ({ qty: parseInt(b.dataset.tierQty, 10), unit: parseInt(b.dataset.tierUnitCents, 10) }))
        .filter(t => !isNaN(t.qty) && !isNaN(t.unit))
        .sort((a, b) => a.qty - b.qty);
      for (const t of tiers) if (t.qty <= qty) unitCents = t.unit;
      // Highlight tier die matcht met huidige qty
      bulkRoot.querySelectorAll('[data-bulk-tier]').forEach(b => {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      let activeTier = null;
      bulkRoot.querySelectorAll('[data-bulk-tier]').forEach(b => {
        const bq = parseInt(b.dataset.tierQty, 10);
        if (bq <= qty && (!activeTier || bq > parseInt(activeTier.dataset.tierQty, 10))) activeTier = b;
      });
      if (activeTier) { activeTier.classList.add('is-active'); activeTier.setAttribute('aria-pressed', 'true'); }
    }
    priceEl.textContent = fmtCents(unitCents * qty);
  }
  // Expose global zodat inline variant-select script 'm kan aanroepen na variant-switch
  window.updateAtcForQty = updateAtcForQty;

  // Qty stepper
  document.querySelectorAll('[data-qty]').forEach(el => {
    const input = el.querySelector('input[name="quantity"]');
    const dec = el.querySelector('[data-qty-dec]');
    const inc = el.querySelector('[data-qty-inc]');
    const display = el.querySelector('[data-qty-display]');
    const set = (v) => {
      const n = Math.max(1, v);
      if(input) input.value = n;
      if(display) display.textContent = n;
      updateAtcForQty(n);
    };
    if (dec) dec.addEventListener('click', () => set(parseInt(input?.value || display?.textContent || 1) - 1));
    if (inc) inc.addEventListener('click', () => set(parseInt(input?.value || display?.textContent || 1) + 1));
  });

  // Bulk-tier selectie op PDP: klik → zet quantity + prijs update
  document.querySelectorAll('[data-bulk-tiers]').forEach(root => {
    const tiers = root.querySelectorAll('[data-bulk-tier]');
    const form = root.closest('form') || document.getElementById('PdpForm');
    if (!form) return;
    const qtyInput = form.querySelector('input[name="quantity"]');
    const qtyDisplay = form.querySelector('[data-qty-display]');
    tiers.forEach(btn => {
      btn.addEventListener('click', () => {
        const n = parseInt(btn.dataset.tierQty, 10) || 1;
        if (qtyInput) qtyInput.value = n;
        if (qtyDisplay) qtyDisplay.textContent = n;
        updateAtcForQty(n);
      });
    });
  });

  // Urgency bar + countdown ("bestel voor [cutoff] → morgen in huis")
  // Reads from window.DFL (set in layout/theme.liquid from Theme Settings)
  // Day/time aware: toont verschillende bericht op werkdag-voor-cutoff,
  // werkdag-na-cutoff (ma-do) en vrijdag-na-cutoff + weekend.
  function getUrgencyState(now, cutoff) {
    const day = now.getDay(); // 0=zo, 1=ma, ..., 5=vr, 6=za
    const afterCutoff = now >= cutoff;
    if (day === 0 || day === 6) return 'weekend';          // za/zo
    if (day === 5 && afterCutoff) return 'weekend';        // vr na cutoff → ma op de bus
    if (afterCutoff) return 'weekday_after';               // ma-do na cutoff
    return 'weekday_before';                               // ma-vr vóór cutoff
  }

  // Check of huidige tijd binnen verberg-window valt.
  // Window mag over middernacht heen lopen (bv. vr 22:00 → ma 00:01).
  function inHideWindow(bar, now) {
    if (bar.dataset.hideEnabled !== 'true') return false;
    const startDay = parseInt(bar.dataset.hideStartDay, 10);
    const endDay   = parseInt(bar.dataset.hideEndDay, 10);
    if (!Number.isFinite(startDay) || !Number.isFinite(endDay)) return false;
    const [sh, sm] = (bar.dataset.hideStartTime || '22:00').split(':').map(n => parseInt(n, 10));
    const [eh, em] = (bar.dataset.hideEndTime   || '00:01').split(':').map(n => parseInt(n, 10));
    if (![sh, sm, eh, em].every(Number.isFinite)) return false;
    const startMin = startDay * 1440 + sh * 60 + sm;
    const endMin   = endDay   * 1440 + eh * 60 + em;
    const nowMin   = now.getDay() * 1440 + now.getHours() * 60 + now.getMinutes();
    if (startMin === endMin) return false;
    if (startMin > endMin) {
      // window wrapt rond Sunday→Monday
      return nowMin >= startMin || nowMin < endMin;
    }
    return nowMin >= startMin && nowMin < endMin;
  }

  function updateCountdown() {
    const H = parseInt(window.DFL?.cutoffHour, 10); const M = parseInt(window.DFL?.cutoffMinute, 10);
    const ch = Number.isFinite(H) ? H : 22; const cm = Number.isFinite(M) ? M : 0;
    const now = new Date();
    const cutoff = new Date(); cutoff.setHours(ch, cm, 0, 0);
    let diff = cutoff - now;
    if (diff < 0) diff += 24*3600*1000;
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const timerText = `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;

    // Update urgency bars (dag/tijd-aware bericht)
    document.querySelectorAll('[data-urgency]').forEach(bar => {
      // Verberg helemaal als binnen ingestelde hide-window
      if (inHideWindow(bar, now)) {
        bar.style.display = 'none';
        return;
      } else if (bar.style.display === 'none') {
        bar.style.display = ''; // herstel als window verstreken (na 00:01 ma)
      }
      const msgEl = bar.querySelector('[data-urgency-msg]');
      if (!msgEl) return;
      const state = getUrgencyState(now, cutoff);
      const i18n = (window.DFL && window.DFL.i18n) || {};
      const tBefore = bar.dataset.textWeekdayBefore || i18n.countdownWeekdayBefore || 'Bestel binnen [timer] voor levering morgen';
      const tAfter  = bar.dataset.textWeekdayAfter  || i18n.countdownWeekdayAfter || 'Bestel nu, morgen gaat je pakket op de bus';
      const tWeekend = bar.dataset.textWeekend      || i18n.countdownWeekend || 'Bestel nu, maandag gaat je pakket op de bus';
      let html;
      if (state === 'weekday_before') {
        html = tBefore.replace('[timer]', `<span class="timer" data-countdown>${timerText}</span>`);
      } else if (state === 'weekday_after') {
        html = tAfter;
      } else {
        html = tWeekend;
      }
      // Alleen DOM aanraken als de text verandert — voorkomt re-render van timer elk seconde als state niet-before is
      if (msgEl.dataset.state !== state) {
        msgEl.innerHTML = html;
        msgEl.dataset.state = state;
      } else if (state === 'weekday_before') {
        // Update alleen de timer-span in-place voor soepele tick
        const t = msgEl.querySelector('[data-countdown]');
        if (t) t.textContent = timerText;
      }
    });

    // Backwards compat: losse [data-countdown] elementen buiten urgency-bars
    document.querySelectorAll('[data-countdown]').forEach(el => {
      if (el.closest('[data-urgency]')) return; // al afgehandeld
      el.textContent = timerText;
    });
  }
  updateCountdown();
  setInterval(updateCountdown, 1000);

  // ---- Globale shipping-window hide voor [data-sw-hide] elementen ----
  // Verbergt elementen die "morgen in huis" / shipping urgency tonen tijdens
  // de window uit Theme Settings (default vr 22:00 → ma 00:01).
  function inGlobalShippingWindow(now) {
    if (window.DFL?.shippingHideEnabled !== true) return false;
    const startDay = parseInt(window.DFL.shippingHideStartDay, 10);
    const endDay = parseInt(window.DFL.shippingHideEndDay, 10);
    if (!Number.isFinite(startDay) || !Number.isFinite(endDay)) return false;
    const [sh, sm] = (window.DFL.shippingHideStartTime || '22:00').split(':').map(n => parseInt(n, 10));
    const [eh, em] = (window.DFL.shippingHideEndTime   || '00:01').split(':').map(n => parseInt(n, 10));
    if (![sh, sm, eh, em].every(Number.isFinite)) return false;
    const startMin = startDay * 1440 + sh * 60 + sm;
    const endMin   = endDay   * 1440 + eh * 60 + em;
    const nowMin   = now.getDay() * 1440 + now.getHours() * 60 + now.getMinutes();
    if (startMin === endMin) return false;
    if (startMin > endMin) return nowMin >= startMin || nowMin < endMin;
    return nowMin >= startMin && nowMin < endMin;
  }
  function applyShippingWindowHide() {
    const now = new Date();
    const hide = inGlobalShippingWindow(now);
    document.querySelectorAll('[data-sw-hide]').forEach(el => {
      if (hide) {
        if (el.dataset.swState !== 'hidden') {
          el.dataset.swPrevDisplay = el.style.display || '';
          el.style.display = 'none';
          el.dataset.swState = 'hidden';
        }
      } else if (el.dataset.swState === 'hidden') {
        el.style.display = el.dataset.swPrevDisplay || '';
        delete el.dataset.swState;
        delete el.dataset.swPrevDisplay;
      }
    });
  }
  applyShippingWindowHide();
  setInterval(applyShippingWindowHide, 60000); // elke minuut updaten

  // Back to top
  const btt = document.querySelector('[data-back-to-top]');
  if (btt) {
    const toggleBtt = () => {
      if (window.scrollY > 600) { btt.hidden = false; requestAnimationFrame(() => btt.classList.add('is-visible')); }
      else { btt.classList.remove('is-visible'); setTimeout(() => { if (!btt.classList.contains('is-visible')) btt.hidden = true; }, 200); }
    };
    window.addEventListener('scroll', toggleBtt, { passive: true });
    btt.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  // Sticky header shadow on scroll
  const hdr = document.querySelector('[data-header]');
  if (hdr) {
    const onScroll = () => hdr.classList.toggle('is-scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Cart drawer
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-overlay');
  const openCart = () => { drawer?.classList.add('open'); overlay?.classList.add('open'); };
  const closeCart = () => { drawer?.classList.remove('open'); overlay?.classList.remove('open'); };
  document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); refreshCart(); }));
  document.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
  overlay?.addEventListener('click', closeCart);

  function money(cents) { return '€' + (cents/100).toFixed(2).replace('.',','); }

  function updateShippingBar(total) {
    const bar = document.querySelector('[data-shipping-bar]');
    const fill = document.querySelector('[data-shipping-fill]');
    const msg = document.querySelector('[data-shipping-msg]');
    if (!bar || !fill || !msg) return;
    const threshold = parseInt(bar.dataset.freeShipThreshold || '5000', 10);
    if (!threshold) { bar.hidden = true; return; }
    const pct = Math.min(100, Math.round((total / threshold) * 100));
    fill.style.width = pct + '%';
    if (total >= threshold) {
      msg.innerHTML = '<strong>' + window.DFL.i18n.freeShippingUnlocked + '</strong>';
      bar.classList.add('is-complete');
    } else {
      const remaining = threshold - total;
      msg.innerHTML = window.DFL.i18n.freeShippingRemaining.replace('{{ amount }}', '<strong>' + money(remaining) + '</strong>');
      bar.classList.remove('is-complete');
    }
  }

  let _protectCleanup = false; // voorkomt een lus bij het opruimen van losse verzendbeveiliging
  async function refreshCart() {
    try {
      const r = await fetch('/cart.js');
      const cart = await r.json();
      const itemsEl = document.querySelector('[data-cart-items]');
      const totalEl = document.querySelector('[data-cart-total]');
      const countEl = document.querySelector('[data-cart-count]');
      const countInlineEl = document.querySelector('[data-cart-count-inline]');
      // Verzendbeveiliging is een los product dat alleen via de schakelaar bestaat:
      // niet als regel tonen, niet meetellen in aantal en gratis-verzending-drempel
      const protectBox = document.querySelector('[data-ship-protect]');
      const protectPid = protectBox ? parseInt(protectBox.dataset.productId, 10) : null;
      const protectLine = protectPid ? cart.items.find(i => i.product_id === protectPid) : null;
      const lines = cart.items.map((item, idx) => ({ item, line: idx + 1 })).filter(l => l.item !== protectLine);
      if (protectLine && !lines.length && !_protectCleanup) {
        // Alleen de beveiliging over: die heeft geen zin zonder bestelling
        _protectCleanup = true;
        await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: protectLine.key, quantity: 0 }) });
        return refreshCart();
      }
      _protectCleanup = false;
      const visibleCount = (cart.item_count || 0) - (protectLine ? protectLine.quantity : 0);
      if (countEl) countEl.textContent = visibleCount;
      if (countInlineEl) countInlineEl.textContent = visibleCount ? '(' + visibleCount + ')' : '';
      updateShippingBar(cart.total_price - (protectLine ? protectLine.final_line_price : 0));
      renderShipProtect(protectBox, protectLine, lines.length > 0);
      if (!itemsEl) return;
      if (!lines.length) {
        itemsEl.innerHTML = '<div class="cart-empty"><p>' + window.DFL.i18n.cartEmpty + '</p><a href="/collections/all" class="cart-empty-cta">' + window.DFL.i18n.viewProducts + '</a></div>';
      } else {
        itemsEl.innerHTML = lines.map(({ item: i, line }) => {
          // Toon originele prijs doorgestreept als er een korting op de regel zit
          const hasLineDiscount = i.original_line_price > i.final_line_price;
          const priceHtml = hasLineDiscount
            ? `<span class="cart-line-price-old">${money(i.original_line_price)}</span> <strong>${money(i.final_line_price)}</strong>`
            : `<strong>${money(i.final_line_price)}</strong>`;
          return `
          <div class="cart-line" data-line-key="${i.key}">
            <img src="${i.image}" class="cart-line-img">
            <div class="cart-line-body">
              <div class="cart-line-title">${i.product_title}</div>
              ${i.variant_title ? `<div class="cart-line-variant">${i.variant_title}</div>` : ''}
              <div class="cart-line-bottom">
                <div class="cart-qty" data-line-qty>
                  <button type="button" data-qty-dec data-line="${line}" aria-label="${window.DFL.i18n.decreaseQuantity}">−</button>
                  <span>${i.quantity}</span>
                  <button type="button" data-qty-inc data-line="${line}" aria-label="${window.DFL.i18n.increaseQuantity}">+</button>
                </div>
                <div class="cart-line-price">${priceHtml}</div>
              </div>
              <button class="cart-line-remove" type="button" data-line-remove="${line}" aria-label="${window.DFL.i18n.remove}">${window.DFL.i18n.remove}</button>
            </div>
          </div>
        `;
        }).join('');
      }
      if (totalEl) totalEl.textContent = money(cart.total_price);

      // Cart-level automatische kortingen (Shopify Function → Shopacado etc)
      const discountsEl = document.querySelector('[data-cart-discounts]');
      const subtotalRow = document.querySelector('[data-cart-subtotal-row]');
      const subtotalEl = document.querySelector('[data-cart-subtotal]');
      const discountRow = document.querySelector('[data-cart-discount-row]');
      const discountEl = document.querySelector('[data-cart-discount]');
      const cartDiscounts = cart.cart_level_discount_applications || [];
      if (discountsEl) {
        if (cartDiscounts.length > 0) {
          discountsEl.innerHTML = cartDiscounts.map(d =>
            `<div class="cart-discount-line">✓ <span class="cart-discount-name">${d.title || window.DFL.i18n.discount}</span><span class="cart-discount-amount">-${money(d.total_allocated_amount)}</span></div>`
          ).join('');
          discountsEl.hidden = false;
        } else {
          discountsEl.innerHTML = '';
          discountsEl.hidden = true;
        }
      }
      if (cart.total_discount > 0) {
        // Subtotaal = pre-discount totaal (original_total_price bestaat in cart.js, fallback op total + discount)
        const preDiscountTotal = cart.original_total_price || (cart.total_price + cart.total_discount);
        if (subtotalRow && subtotalEl) { subtotalEl.textContent = money(preDiscountTotal); subtotalRow.hidden = false; }
        if (discountRow && discountEl) { discountEl.textContent = '-' + money(cart.total_discount); discountRow.hidden = false; }
      } else {
        if (subtotalRow) subtotalRow.hidden = true;
        if (discountRow) discountRow.hidden = true;
      }

      // bind qty/remove
      itemsEl.querySelectorAll('[data-qty-inc]').forEach(b => b.addEventListener('click', () => changeQty(b, +1)));
      itemsEl.querySelectorAll('[data-qty-dec]').forEach(b => b.addEventListener('click', () => changeQty(b, -1)));
      itemsEl.querySelectorAll('[data-line-remove]').forEach(b => b.addEventListener('click', () => setQty(b.dataset.lineRemove, 0)));

      // Upsell (cart drawer)
      renderUpsell(cart, protectPid);
    } catch(e){ console.error(e); }
  }

  // ---------- PDP "Vaak samen besteld" (frequently bought together) ----------
  (function initFbt(){
    const fbt = document.querySelector('.pdp-fbt');
    if (!fbt) return;
    const totalEl = fbt.querySelector('[data-fbt-total]');
    const baseCents = parseInt(totalEl?.dataset.fbtBase, 10) || 0;
    function money(cents){ return '€' + (cents/100).toFixed(2).replace('.', ','); }

    function recalc() {
      let total = baseCents;
      fbt.querySelectorAll('[data-fbt-toggle]').forEach(input => {
        if (input.checked) total += parseInt(input.dataset.fbtPrice, 10) || 0;
        // Mark the parent item visually unchecked
        const item = input.closest('.pdp-fbt-item');
        if (item) item.classList.toggle('is-unchecked', !input.checked);
      });
      if (totalEl) totalEl.textContent = money(total);
    }

    fbt.querySelectorAll('[data-fbt-toggle]').forEach(input => {
      input.addEventListener('change', recalc);
    });
    recalc();

    const addBtn = fbt.querySelector('[data-fbt-add-all]');
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const items = [];
        // Always include current product (main ATC handles)
        fbt.querySelectorAll('[data-fbt-add]').forEach(item => {
          const toggle = item.querySelector('[data-fbt-toggle]');
          if (toggle && toggle.checked) {
            items.push({ id: parseInt(item.dataset.fbtAdd, 10), quantity: 1 });
          }
        });
        if (!items.length) return;
        // Also add the current PDP product (via main form variant id)
        const mainVariantSelect = document.querySelector('[data-variant-select]');
        if (mainVariantSelect && mainVariantSelect.value) {
          items.unshift({ id: parseInt(mainVariantSelect.value, 10), quantity: 1 });
        }
        const origText = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = window.DFL.i18n.addAllLoading;
        try {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!r.ok) throw new Error('add failed');
          addBtn.textContent = window.DFL.i18n.added;
          // Open cart drawer
          document.querySelector('[data-cart-open]')?.click();
        } catch(err) {
          addBtn.disabled = false;
          addBtn.textContent = origText;
          alert(window.DFL.i18n.addFailedShort);
        }
      });
    }
  })();

  // ---------- Verzendbeveiliging (cart drawer) ----------
  function renderShipProtect(box, protectLine, hasItems) {
    if (!box) return;
    box.hidden = !hasItems;
    const toggle = box.querySelector('[data-ship-protect-toggle]');
    if (!toggle) return;
    toggle.checked = !!protectLine;
    toggle.dataset.lineKey = protectLine ? protectLine.key : '';
    if (toggle.dataset.bound) return;
    toggle.dataset.bound = '1';
    toggle.addEventListener('change', async () => {
      toggle.disabled = true;
      try {
        const r = toggle.checked
          ? await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: parseInt(box.dataset.variantId, 10), quantity: 1 }) })
          : await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: toggle.dataset.lineKey, quantity: 0 }) });
        if (!r.ok) throw new Error('ship protect failed');
      } catch(err) {
        console.error(err);
        toggle.checked = !toggle.checked;
        alert(window.DFL.i18n.addFailedShort);
      } finally {
        toggle.disabled = false;
        await refreshCart();
      }
    });
  }

  // ---------- Cart upsell ----------
  let _upsellCache = null; // cache products per session
  function bindUpsellAdd(container) {
    // Variant-dropdown: prijs, afbeelding, links en knop volgen de gekozen variant
    container.querySelectorAll('[data-upsell-variant]').forEach(sel => {
      if (sel.dataset.bound) return;
      sel.dataset.bound = '1';
      sel.addEventListener('change', () => {
        const card = sel.closest('.cart-upsell-card');
        const opt = sel.options[sel.selectedIndex];
        if (!card || !opt) return;
        card.dataset.upsellId = opt.value;
        const btn = card.querySelector('[data-upsell-add]');
        if (btn) btn.dataset.upsellAdd = opt.value;
        const pct = parseInt(opt.dataset.pct, 10) || 0;
        const setText = (sel, text, show) => card.querySelectorAll(sel).forEach(el => { el.textContent = text; el.hidden = !show; });
        setText('[data-upsell-now]', opt.dataset.price || '', true);
        setText('[data-upsell-was]', opt.dataset.compare || '', !!opt.dataset.compare);
        setText('[data-upsell-save]', window.DFL.i18n.upsellSave.replace('{{ pct }}', pct), pct > 0);
        setText('[data-upsell-badge]', '-' + pct + '%', pct > 0);
        const img = card.querySelector('[data-upsell-img]');
        if (img && opt.dataset.img) img.src = opt.dataset.img;
        if (opt.dataset.url) card.querySelectorAll('[data-upsell-link]').forEach(a => { a.href = opt.dataset.url; });
      });
    });
    // PDP add-on: vinkje markeert de kaart; meesturen gebeurt in de ATC-submit-handler
    container.querySelectorAll('[data-upsell-addon]').forEach(cb => {
      if (cb.dataset.bound) return;
      cb.dataset.bound = '1';
      cb.addEventListener('change', () => cb.closest('.cart-upsell-card')?.classList.toggle('is-selected', cb.checked));
    });
    container.querySelectorAll('[data-upsell-add]').forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', async () => {
        const vid = btn.dataset.upsellAdd;
        const origText = btn.textContent;
        btn.disabled = true;
        btn.textContent = window.DFL.i18n.adding;
        try {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
          });
          if (!r.ok) throw new Error('add failed');
          btn.textContent = window.DFL.i18n.added;
          // Na verversen weer klikbaar maken: de kaart verdwijnt zolang het product
          // in de winkelwagen zit en moet na verwijderen opnieuw bruikbaar zijn
          setTimeout(async () => {
            await refreshCart();
            btn.disabled = false;
            btn.textContent = window.DFL.i18n.add;
          }, 400);
        } catch(err) {
          btn.disabled = false;
          btn.textContent = origText;
          alert(window.DFL.i18n.addFailedShort);
        }
      });
    });
  }
  async function renderUpsell(cart, protectPid) {
    const box = document.querySelector('[data-cart-upsell]');
    if (!box) return; // upsell disabled in settings
    const container = box.querySelector('[data-cart-upsell-items]');
    if (!container) return;

    const mode = box.dataset.upsellMode || 'collection';

    // Alleen tonen als er een hoofdproduct (bv. fotolijst) in de winkelwagen zit,
    // dus niet wanneer er alleen upsell-producten of verzendbeveiliging in zitten
    const upsellPids = new Set(mode === 'specific'
      ? [...container.querySelectorAll('[data-upsell-product-id]')].map(c => parseInt(c.dataset.upsellProductId, 10))
      : (_upsellCache || []).map(p => p.id));
    const hasMainItem = (cart.items || []).some(i => i.product_id !== protectPid && !upsellPids.has(i.product_id));
    if (!hasMainItem && (mode === 'specific' || _upsellCache)) { box.hidden = true; return; }
    if (!cart.items || !cart.items.length) { box.hidden = true; return; }

    // SPECIFIC mode: server-side gerendered cards filteren op cart contents
    if (mode === 'specific') {
      const inCartProductIds = new Set(cart.items.map(i => String(i.product_id)));
      const cards = container.querySelectorAll('[data-upsell-product-id]');
      let visibleCount = 0;
      cards.forEach(card => {
        const pid = card.dataset.upsellProductId;
        if (inCartProductIds.has(pid)) {
          card.style.display = 'none';
        } else {
          card.style.display = '';
          visibleCount++;
        }
      });
      bindUpsellAdd(container);
      box.hidden = visibleCount === 0;
      return;
    }

    // COLLECTION mode: fetch + shuffle (legacy gedrag)
    const handle = box.dataset.upsellCollection;
    const count = parseInt(box.dataset.upsellCount, 10) || 3;
    if (!handle) { box.hidden = true; return; }

    try {
      if (!_upsellCache) {
        const r = await fetch(`/collections/${handle}/products.json?limit=50`);
        const d = await r.json();
        _upsellCache = d.products || [];
      }
      const cacheIds = new Set(_upsellCache.map(p => p.id));
      if (!cart.items.some(i => i.product_id !== protectPid && !cacheIds.has(i.product_id))) { box.hidden = true; return; }
      const inCartIds = new Set(cart.items.map(i => i.product_id));
      const candidates = _upsellCache.filter(p => !inCartIds.has(p.id) && p.available);
      if (!candidates.length) { box.hidden = true; return; }

      // Shuffle + pick N
      const picks = candidates.sort(() => Math.random() - 0.5).slice(0, count);

      const esc = (str) => String(str ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const cents = (price) => Math.round(parseFloat(price) * 100);
      container.innerHTML = picks.map(p => {
        const variants = p.variants || [];
        const variant = variants.find(v => v.available) || variants[0];
        if (!variant) return '';
        const fallbackImg = (p.images && p.images[0]) ? p.images[0].src : '';
        const imgOf = (v) => (v.featured_image && v.featured_image.src) || fallbackImg;
        const compareOf = (v) => (v.compare_at_price && cents(v.compare_at_price) > cents(v.price)) ? money(cents(v.compare_at_price)) : '';
        const pctOf = (v) => compareOf(v) ? Math.round((cents(v.compare_at_price) - cents(v.price)) * 100 / cents(v.compare_at_price)) : 0;
        const pct = pctOf(variant);
        const urlOf = (v) => `/products/${p.handle}?variant=${v.id}`;
        const img = imgOf(variant);
        const compare = compareOf(variant);
        const select = variants.length > 1 ? `
              <select class="cart-upsell-card-select" data-upsell-variant aria-label="${esc(window.DFL.i18n.chooseVariant)}: ${esc(p.title)}">
                ${variants.map(v => `<option value="${v.id}" data-price="${money(cents(v.price))}" data-compare="${compareOf(v)}" data-pct="${pctOf(v)}" data-url="${urlOf(v)}" data-img="${esc(imgOf(v))}"${v.id === variant.id ? ' selected' : ''}${v.available ? '' : ' disabled'}>${esc(v.title)} · ${money(cents(v.price))}${v.available ? '' : ` (${esc(window.DFL.i18n.soldOut)})`}</option>`).join('')}
              </select>` : '';
        return `
          <div class="cart-upsell-card" data-upsell-id="${variant.id}">
            <a href="${urlOf(variant)}" class="cart-upsell-card-media" data-upsell-link>
              ${img ? `<img src="${esc(img)}" alt="${esc(p.title)}" loading="lazy" data-upsell-img>` : ''}
              <span class="cart-upsell-card-badge" data-upsell-badge${pct ? '' : ' hidden'}>-${pct}%</span>
            </a>
            <div class="cart-upsell-card-body">
              <a href="${urlOf(variant)}" class="cart-upsell-card-title" data-upsell-link>${esc(p.title)}</a>
              <div class="cart-upsell-card-price">
                <span class="cart-upsell-card-now" data-upsell-now>${money(cents(variant.price))}</span>
                <s class="cart-upsell-card-was" data-upsell-was${compare ? '' : ' hidden'}>${compare}</s>
                <span class="cart-upsell-card-save" data-upsell-save${pct ? '' : ' hidden'}>${esc(window.DFL.i18n.upsellSave.replace('{{ pct }}', pct))}</span>
              </div>
              <div class="cart-upsell-card-actions">${select}
                <button type="button" class="cart-upsell-card-add" data-upsell-add="${variant.id}">${window.DFL.i18n.add}</button>
              </div>
            </div>
          </div>
        `;
      }).join('');

      bindUpsellAdd(container);
      box.hidden = false;
    } catch(e) { console.error('upsell error', e); box.hidden = true; }
  }

  async function changeQty(btn, delta) {
    const el = btn.closest('[data-line-qty]')?.querySelector('span');
    if (!el) return;
    const cur = parseInt(el.textContent, 10) || 1;
    await setQty(btn.dataset.line, Math.max(0, cur + delta));
  }
  async function setQty(line, qty) {
    try {
      await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ line: parseInt(line,10), quantity: parseInt(qty,10) }) });
      await refreshCart();
    } catch(e){ console.error(e); }
  }

  document.querySelectorAll('[data-pdp-addons]').forEach(bindUpsellAdd);

  // Intercept ATC forms
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    if (btn) { btn.disabled = true; btn.dataset.origText = btn.textContent; btn.textContent = window.DFL.i18n.adding; }
    try {
      const fd = new FormData(form);
      const r = await fetch('/cart/add.js', { method:'POST', body: fd });
      if (!r.ok) throw new Error('add failed');
      // Aangevinkte PDP-add-ons (bv. SD-kaart) meesturen; mislukken mag de hoofdbestelling niet blokkeren
      const addons = [...form.querySelectorAll('[data-upsell-addon]:checked')];
      const addonItems = addons.map(cb => ({ id: parseInt(cb.closest('.cart-upsell-card')?.dataset.upsellId, 10), quantity: 1 })).filter(i => i.id);
      if (addonItems.length) {
        try {
          const ra = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: addonItems }) });
          if (!ra.ok) throw new Error('addon add failed');
          addons.forEach(cb => { cb.checked = false; cb.dispatchEvent(new Event('change')); });
        } catch(err) { console.error(err); }
      }
      await refreshCart();
      openCart();
      if (btn) { btn.classList.add('added'); btn.textContent = window.DFL.i18n.addedExcl; }
      setTimeout(() => { if(btn){ btn.disabled=false; btn.classList.remove('added'); btn.textContent = btn.dataset.origText || window.DFL.i18n.inCart; } }, 2000);
    } catch(err) {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.origText || window.DFL.i18n.inCart; }
      alert(window.DFL.i18n.addFailed);
    }
  });

  // Predictive search
  const searchInput = document.querySelector('[data-predictive-search]');
  const searchResults = document.querySelector('[data-predictive-results]');
  let searchDebounce;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchDebounce);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; searchResults.style.display='none'; return; }
      searchDebounce = setTimeout(async () => {
        try {
          const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`);
          const d = await r.json();
          const prods = d.resources?.results?.products || [];
          if (!prods.length) { searchResults.innerHTML = '<div style="padding:16px;color:var(--c-muted);font-size:13px">' + window.DFL.i18n.noResults + '</div>'; searchResults.style.display='block'; return; }
          searchResults.innerHTML = prods.map(p => `
            <a href="${p.url}" style="display:flex;gap:10px;padding:10px 14px;border-bottom:1px solid var(--c-border);color:var(--c-text)">
              <img src="${p.image}" style="width:44px;height:44px;object-fit:cover;border-radius:4px">
              <div style="flex:1">
                <div style="font-size:13px;font-weight:600">${p.title}</div>
                <div style="font-size:12px;color:var(--c-muted)">${p.price}</div>
              </div>
            </a>
          `).join('');
          searchResults.style.display='block';
        } catch(e){ console.error(e); }
      }, 200);
    });
    document.addEventListener('click', (e) => {
      if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) { searchResults.style.display='none'; }
    });
  }

  // Initial cart refresh
  refreshCart();
})();
